import { useQuery } from '@tanstack/react-query';
import type { TaskStatus } from 'scheduler-types';
import { apiFetch } from '../lib/api';

export interface LineItemTask {
  id: string;
  laborBucket: string;
  status: TaskStatus;
  estimatedMinutesMin: number;
  estimatedMinutesMax: number;
  actualMinutes: number | null;
  scheduledStart: string | null;
  scheduledEnd: string | null;
  assignedPersonId: string | null;
  assignedPersonName: string | null;
  isExpediteEligible: boolean;
  isPinned: boolean;
}

interface LineItemWithTasks {
  id: string;
  partNumber: string;
  quantity: number;
  bomId: string | null;
  schedulingStatus: string;
  tasks: LineItemTask[];
}

async function fetchLineItemTasks(lineItemId: string): Promise<LineItemTask[]> {
  const json = await apiFetch<{ data: LineItemWithTasks }>(`/api/v1/line-items/${lineItemId}`);
  if (!json.data) {
    console.error('[useLineItemTasks] No data in response for line item:', lineItemId);
    throw new Error('No data returned for line item');
  }
  if (!Array.isArray(json.data.tasks)) {
    console.warn('[useLineItemTasks] tasks field is not an array:', typeof json.data.tasks);
    return [];
  }
  return json.data.tasks;
}

export function useLineItemTasks(lineItemId: string | undefined) {
  return useQuery({
    queryKey: ['lineItemTasks', lineItemId],
    queryFn: () => fetchLineItemTasks(lineItemId!),
    enabled: !!lineItemId,
    staleTime: 30000,
  });
}
